import React from 'react';
import filterProps from 'utils/filterProps';
import { Button } from 'elements';
import { BackgroundImg } from 'elements/util';
import { VideoPlay } from 'core/icons';
import {
  StyledThumbnail,
  Duration,
  Overlay,
} from './styled';

const ThumbnailVideo = ({ duration, onPlayClick, a11yLabel, poster, posterAlign, src, compact, ...rest }) => {
  const dataAttrs = filterProps(rest, /^data-/);
  const appearanceProps = {
    compact
  };
  return (
    <StyledThumbnail {...appearanceProps}>

      <BackgroundImg
        {...dataAttrs}
        src={poster}
        alt=''
        align={posterAlign}
      />

      <Overlay {...appearanceProps} >

          <Button
            tabIndex='-1'
            a11yLabel={a11yLabel}
            icon={VideoPlay}
            iconSize='large'
            type='text'
            onClick={onPlayClick}
          />

          <Duration {...appearanceProps}>
            {duration}
          </Duration>

        </Overlay>

    </StyledThumbnail>
  );
};

export default ThumbnailVideo;



// WEBPACK FOOTER //
// ./src/elements/Card/components/ThumbnailVideo/ThumbnailVideo.jsx